import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getCorgiAIToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.CorgiAI,
    symbol: 'CorgiAI',
    addressL1: sdks.L1.getContractAddress('CorgiAI'),
    addressL2: sdks.L2.getContractAddress('CorgiAI'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/corgiai.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="Corgi AI"
        {...props}
      />
    ),
  };
};
